import type {
  RequestActionCreator,
  RequestSuccessActionCreator,
  RequestFailureActionCreator,
} from "./types";

export const ADDRESSES_EXPORT_POST_REQUEST = "ADDRESSES_EXPORT_POST_REQUEST";
export const ADDRESSES_EXPORT_POST_REQUEST_SUCCESS =
  "ADDRESSES_EXPORT_POST_REQUEST_SUCCESS";
export const ADDRESSES_EXPORT_POST_REQUEST_FAILURE =
  "ADDRESSES_EXPORT_POST_REQUEST_FAILURE";
export const ADDRESSES_EXPORT_POST_RESET = "ADDRESSES_EXPORT_POST_RESET";
export const ADDRESSES_EXPORT_LISTEN = "ADDRESSES_EXPORT_LISTEN";
export const ADDRESSES_EXPORT_DOWNLOAD_CLICKED =
  "ADDRESSES_EXPORT_DOWNLOAD_CLICKED";
export const DOWNLOAD_CLICKED = ADDRESSES_EXPORT_DOWNLOAD_CLICKED;

export const SOCKET_EVENT_OBJECTS_ADDRESSES_ARCHIVE_GENERATION =
  "SOCKET_EVENT_OBJECTS_ADDRESSES_ARCHIVE_GENERATION";
export const SOCKET_EVENT_OBJECTS_ADDRESSES_ARCHIVE_GENERATION_ERROR =
  "SOCKET_EVENT_OBJECTS_ADDRESSES_ARCHIVE_GENERATION_ERROR";

export const request: RequestActionCreator = (
  payload,
  tenantId,
  resolve,
  reject
) => ({
  type: ADDRESSES_EXPORT_POST_REQUEST,
  payload,
  tenantId,
  resolve,
  reject,
});

export const requestSuccess: RequestSuccessActionCreator = (
  tenantId,
  data
) => ({
  type: ADDRESSES_EXPORT_POST_REQUEST_SUCCESS,
  data,
  tenantId,
});

export const requestFailure: RequestFailureActionCreator = (
  tenantId,
  error
) => ({
  type: ADDRESSES_EXPORT_POST_REQUEST_FAILURE,
  error,
  tenantId,
});

export const downloadClicked = () => ({
  type: ADDRESSES_EXPORT_DOWNLOAD_CLICKED,
});

export const listen = (tenantId: string) => ({
  type: ADDRESSES_EXPORT_LISTEN,
  tenantId,
});

export const reset = () => ({
  type: ADDRESSES_EXPORT_POST_RESET,
});
